'use client'

import React from 'react'

export type LandingGlyphKind =
  | 'market'
  | 'portfolio'
  | 'agent'
  | 'activity'
  | 'connection'
  | 'workspace'

type LandingGlyphProps = {
  kind: LandingGlyphKind
}

export const LandingGlyph: React.FC<LandingGlyphProps> = ({ kind }) => (
  <svg
    className={`landing-glyph landing-glyph-${kind}`}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
  >
    <rect className="landing-glyph-frame" x="2.5" y="2.5" width="27" height="27" rx="3.5" />

    {kind === 'market' ? (
      <>
        <path d="M7 23V9M7 23H25" />
        <path className="landing-glyph-accent" d="m9 20 4-5 4 2 6-8" />
        <circle className="landing-glyph-node" cx="23" cy="9" r="1.7" />
      </>
    ) : null}

    {kind === 'portfolio' ? (
      <>
        <path d="M16 7.5a8.5 8.5 0 1 0 8.5 8.5H16V7.5Z" />
        <path className="landing-glyph-accent" d="M18.5 7.9a7 7 0 0 1 5.6 5.6h-5.6V7.9Z" />
        <path d="M10 21.5h4M10 18.5h2" />
      </>
    ) : null}

    {kind === 'agent' ? (
      <>
        <path d="M9 14.5 11.5 9h9L23 14.5v7L19.5 24h-7L9 21.5v-7Z" />
        <path className="landing-glyph-accent" d="M11.5 15.5h9" />
        <circle className="landing-glyph-node" cx="13" cy="19.5" r="1.2" />
        <circle className="landing-glyph-node" cx="19" cy="19.5" r="1.2" />
      </>
    ) : null}

    {kind === 'activity' ? (
      <>
        <path d="M8 10h8l3 3h5M8 22h8l3-3h5" />
        <path className="landing-glyph-accent" d="m21 10 3 3-3 3M21 16l3 3-3 3" />
        <circle className="landing-glyph-node" cx="8" cy="10" r="1.5" />
        <circle className="landing-glyph-node" cx="8" cy="22" r="1.5" />
      </>
    ) : null}

    {kind === 'connection' ? (
      <>
        <circle cx="9" cy="16" r="3" />
        <circle cx="23" cy="10" r="3" />
        <circle cx="23" cy="22" r="3" />
        <path d="m12 15 8-4M12 17l8 4" />
        <circle className="landing-glyph-node" cx="9" cy="16" r="1.2" />
      </>
    ) : null}

    {kind === 'workspace' ? (
      <>
        <path d="M7.5 8.5h17v15h-17zM7.5 13h17M13 13v10.5" />
        <path className="landing-glyph-accent" d="M16 17h5M16 20h3" />
        <circle className="landing-glyph-node" cx="10" cy="10.8" r="0.9" />
      </>
    ) : null}
  </svg>
)
